const React = require('react')
const { useHistory, useLocation } = require('react-router-dom')
const { useNetworkConfig } = require('@contexts')

require('@styles/pages/verifyContract/index.css')

const SimilarContract = props => {
    const { similarContract } = props
    const history = useHistory()
    const { network } = useNetworkConfig()

    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const contractAddress = params.get('a')

    return (
        <div className='box table-section'>
            Note: This&nbsp;
            <span
                className={`${network.name}-text-color cursor-pointer`}
                onClick={() => history.push(`/${network.name}/address/${contractAddress}`)}
            >
                Contract
            </span>
            &nbsp;
            <span style={{ fontWeight: 'bold' }}>Similar Matches</span>
            &nbsp;the deployed Bytecode at&nbsp;
            <span
                className={`${network.name}-text-color cursor-pointer`}
                onClick={() => history.push(`/${network.name}/address/${similarContract}`)}
            >
                {similarContract}
            </span>
            , additional source code verification (with the current user credential) is temporarily unavailable.
        </div>
    )
}

module.exports = { SimilarContract }
